import { ActionTypes } from "@/App/constants/actionTypes";
import { DrugTypes } from "@/types";

type RemoveDrugAction = {
  type: typeof ActionTypes.REMOVE_SELECTED_DRUG;
  payload: DrugTypes.DrugResult;
};

export const removeDrugAction = (data: DrugTypes.DrugResult): RemoveDrugAction => {
  return {
    type: ActionTypes.REMOVE_SELECTED_DRUG,
    payload: data,
  };
};

export type DrugRemoveActions = RemoveDrugAction;
